import { useTranslation } from 'react-i18next';

import type { Course } from '../features/instructor/instructorApi';

interface ClassSelectorProps {
  courses: Course[];
  selectedCourseId: string;
  onChange: (courseId: string) => void;
  label?: string;
}

function ClassSelector({ courses, selectedCourseId, onChange, label }: ClassSelectorProps) {
  const { t } = useTranslation();

  if (courses.length < 2) {
    return courses.length === 1 ? <p>{courses[0].title}</p> : null;
  }

  return (
    <label>
      {label ?? t('instructor.selectedClass')}
      <select
        aria-label={label ?? t('instructor.selectedClass')}
        value={selectedCourseId}
        onChange={(event) => onChange(event.target.value)}
      >
        {courses.map((course) => (
          <option key={course.id} value={course.id}>
            {course.title}
          </option>
        ))}
      </select>
    </label>
  );
}

export default ClassSelector;
